import React from 'react';
import type { FC, ReactNode } from 'react';

export enum NavbarType {
    LIGHT = 'light',
    DARK = 'dark',
}

interface NavbarProps {
    leading?: ReactNode;
    trailing?: ReactNode;
    center?: ReactNode;
    type?: NavbarType;
}

export const Navbar: FC<NavbarProps> = ({ leading, trailing, center, type }) => {
    return (
        <div
            className={`flex flex-col-3 max-w-full min-h-[56px] max-h-[56px] justify-between ${type === NavbarType.LIGHT ? 'bg-gray-160' : 'bg-black-50'} px-6 py-2 vertical-center items-center`}
        >
            {leading ? leading : <div />}
            {center ? center : <div />}
            {trailing ? trailing : <div />}
        </div>
    );
};
